import React from 'react';
import Abbr from '../../../shared/Abbr';

const CrsHeader = () => (
    <Abbr
        title="Course / Conditions / Prize"
        breakpoint="fromMedium"
    >
        <span className="hidden-sm-up">
            Crs.
        </span>
        <span className="hidden-xs-down hidden-md-up">
            Crs / Class / Type
        </span>
    </Abbr>
);

export default CrsHeader;



// WEBPACK FOOTER //
// ./src/js/human/form/components/CourseHeader.jsx